import img1 from '../images/common/1.png'
import img2 from '../images/common/2.png'
import img3 from '../images/common/3.png'
import img4 from '../images/common/4.png'
import img5 from '../images/common/5.png'
import img6 from '../images/common/6.png'
import img7 from '../images/common/7.png'
import img8 from '../images/common/8.png'
import img9 from '../images/common/9.png'
import img10 from '../images/common/10.png'
import img11 from '../images/common/11.png'
import img12 from '../images/common/12.png'
import img13 from '../images/common/13.png'
import img14 from '../images/common/14.png'
import img15 from '../images/common/15.png'
import img16 from '../images/common/16.png'
import img17 from '../images/common/17.png'
import img18 from '../images/common/18.png'
import img19 from '../images/common/19.png'
import img20 from '../images/common/20.png'
import img21 from '../images/common/21.png'
import img22 from '../images/common/22.png'
import img23 from '../images/common/23.png'
import img24 from '../images/common/24.png'
import img25 from '../images/common/25.png'
import img26 from '../images/common/26.png'
import img27 from '../images/common/27.png'
import img28 from '../images/common/28.png'
import img29 from '../images/common/29.png'
import img30 from '../images/common/30.png'
import img31 from '../images/common/31.png'
import img32 from '../images/common/32.png'
import img33 from '../images/common/33.png'
import img34 from '../images/common/34.png'
import img35 from '../images/common/35.png'
import img36 from '../images/common/36.png'
import img37 from '../images/common/37.png'
import img38 from '../images/common/38.png'
import img39 from '../images/common/39.png'
import img40 from '../images/common/40.png'
import img41 from '../images/common/41.png'
import img42 from '../images/common/42.png'
import img43 from '../images/common/43.png'
import img44 from '../images/common/44.png'
import img45 from '../images/common/45.png'
import img46 from '../images/common/46.png'
import img47 from '../images/common/47.png'
import img48 from '../images/common/48.png'
import img49 from '../images/common/49.png'
import img50 from '../images/common/50.png'
import img51 from '../images/common/51.png'
import img52 from '../images/common/52.png'
import img53 from '../images/common/53.png'
import img54 from '../images/common/54.png'
import img55 from '../images/common/55.png'
import img56 from '../images/common/56.png'
import img57 from '../images/common/57.png'
import img58 from '../images/common/58.png'
import img59 from '../images/common/59.png'
import img60 from '../images/common/60.png'

import img61 from '../images/common/61.png'
import img62 from '../images/common/62.png'
import img63 from '../images/common/63.png'
import img64 from '../images/common/64.png'
import img65 from '../images/common/65.png'
import img66 from '../images/common/66.png'
import img67 from '../images/common/67.png'
import img68 from '../images/common/68.png'
import img69 from '../images/common/69.png'
import img70 from '../images/common/70.png'
import img71 from '../images/common/71.png'
import img72 from '../images/common/72.png'
import img73 from '../images/common/73.png'
import img74 from '../images/common/74.png'
import img75 from '../images/common/75.png'
import img76 from '../images/common/76.png'
import img77 from '../images/common/77.png'
import img78 from '../images/common/78.png'
import img79 from '../images/common/79.png'
import img80 from '../images/common/80.png'
import img81 from '../images/common/81.png'
import img82 from '../images/common/82.png'
import img83 from '../images/common/83.png'
import img84 from '../images/common/84.png'
import img85 from '../images/common/85.png'
import img86 from '../images/common/86.png'
import img87 from '../images/common/87.png'
import img88 from '../images/common/88.png'
import img89 from '../images/common/89.png'
import img90 from '../images/common/90.png'
import img91 from '../images/common/91.png'
import img92 from '../images/common/92.png'
import img93 from '../images/common/93.png'
import img94 from '../images/common/94.png'
import img95 from '../images/common/95.png'
import img96 from '../images/common/96.png'
import img97 from '../images/common/97.png'
import img98 from '../images/common/98.png'
import img99 from '../images/common/99.png'
import img100 from '../images/common/100.png'
import img101 from '../images/common/101.png'
import img102 from '../images/common/102.png'
import img103 from '../images/common/103.png'
import img104 from '../images/common/104.png'
import img105 from '../images/common/105.png'
import img106 from '../images/common/106.png'
import img107 from '../images/common/107.png'
import img108 from '../images/common/108.png'
import img109 from '../images/common/109.png'
import img110 from '../images/common/110.png'
import img111 from '../images/common/111.png'


import img112 from '../images/common/112.png' 
import img113 from '../images/common/113.png' 
import img114 from '../images/common/114.png' 
import img115 from '../images/common/115.png' 
import img116 from '../images/common/116.png' 
import img117 from '../images/common/117.png' 
import img118 from '../images/common/118.png' 
import img119 from '../images/common/119.png' 
import img120 from '../images/common/120.png' 
import img121 from '../images/common/121.png'
import img122 from '../images/common/122.png'
import img123 from '../images/common/123.png'
import img124 from '../images/common/124.png'   



const dataProject = [
    {
        id: 1,
        //title: 'Block Pirate #01',
        img: img1,
    },
    {
        id: 2,
        //title: 'Block Pirate #02',
        img: img2,
    },
    {
        id: 3,
        //title: 'Block Pirate #03',
        img: img3,
    },
    {
        id: 4,
        //title: 'Block Pirate #04',
        img: img4,
    },
    {
        id: 5,
        //title: 'Block Pirate #05',
        img: img5,
    },
    {
        id: 6,
        //title: 'Block Pirate #06',
        img: img6,
    },
    {
        id: 7,
        //title: 'Block Pirate #07',
        img: img7,
    },
    {
        id: 8,
        //title: 'Block Pirate #08',
        img: img8,
    },

    {
        id: 9,
        //title: 'Block Pirate #09',
        img: img9,
    },
    {
        id: 10,
        //title: 'Block Pirate #10',
        img: img10,
    },
    {
        id: 11,
        //title: 'BCPE #11',
        img: img11,
    },
    {
        id: 12,
        //title: 'BCPE #12',
        img: img12,
    },
    {
        id: 13,
        //title: 'BCPE #13',
        img: img13,
    },
    {
        id: 14,
        //title: 'BCPE #14',
        img: img14,
    },
    {
        id: 15,
        //title: 'BCPE #15',
        img: img15,
    },
    {
        id: 16,
        //title: 'BCPE #16',
        img: img16,
    },
    {
        id: 17,
        //title: 'BCPE #17',
        img: img17,
    },
    {
        id: 18,
        //title: 'BCPE #18',
        img: img18,
    },
    {
        id: 19,
        //title: 'BCPE #19',
        img: img19,
    },
    {
        id: 20,
        //title: 'BCPE #20',
        img: img20,
    },

    {
        id: 21,
        //title: 'BCPE #21',
        img: img21,
    },

    {
        id: 22,
        //title: 'BCPE #22',
        img: img22,
    },

    {
        id: 23,
        //title: 'BCPE #23',
        img: img23,
    },


    {
        id: 24,
        //title: 'BCPE #24',
        img: img24,
    },

    {
        id: 25,
        //title: 'BCPE #25',
        img: img25,
    },

    {
        id: 26,
        //title: 'BCPE #26',
        img: img26,
    },

    {
        id: 27,
        //title: 'BCPE #27',
        img: img27,
    },

    {
        id: 28,
        //title: 'BCPE #28',
        img: img28,
    },
    {
        id: 29,
        //title: 'BCPE #29',
        img: img29,
    },

    {
        id: 30,
        //title: 'BCPE #30',
        img: img30,
    },
    {
        id: 31,
        //title: 'BCPE #30',
        img: img31,
    },

    {
        id: 32,
        //title: 'BCPE #30',
        img: img32,
    },
    {
        id: 33,
        //title: 'BCPE #30',
        img: img33,
    },

    {
        id: 34,
        //title: 'BCPE #30',
        img: img34,
    },
    {
        id: 35,
        //title: 'BCPE #30',
        img: img35,
    },

    {
        id: 36,
        //title: 'BCPE #30',
        img: img36,
    },

    {
        id: 37,
        //title: 'BCPE #30',
        img: img37,
    },
    {
        id: 38,
        //title: 'BCPE #30',
        img: img38,
    },
    {
        id: 39,
        //title: 'BCPE #30',
        img: img39,
    },
    {
        id: 40,
        //title: 'BCPE #30',
        img: img40,
    },

    {
        id: 41,
        //title: 'BCPE #30',
        img: img41,
    },

    {
        id: 42,
        //title: 'BCPE #30',
        img: img42,
    },
    {
        id: 43,
        //title: 'BCPE #30',
        img: img43,
    },
    {
        id: 44,
        //title: 'BCPE #30',
        img: img44,
    },

    {
        id: 45,
        //title: 'BCPE #30',
        img: img45,
    },
    {
        id: 46,
        //title: 'BCPE #30',
        img: img46,
    },
    {
        id: 47,
        //title: 'BCPE #30',
        img: img47,
    },
    {
        id: 48,
        //title: 'BCPE #30',
        img: img48,
    },
    {
        id: 49,
        //title: 'BCPE #30',
        img: img49,
    },
    {
        id: 50,
        //title: 'BCPE #30',
        img: img50,
    },
    {
        id: 51,
        //title: 'BCPE #30',
        img: img51,
    },
    {
        id: 52,
        //title: 'BCPE #30',
        img: img52,
    },
    {
        id: 53,
        //title: 'BCPE #30',
        img: img53,
    },
    {
        id: 54,
        //title: 'BCPE #30',
        img: img54,
    },
    {
        id: 55,
        //title: 'BCPE #30',
        img: img55,
    },
    {
        id: 56,
        //title: 'BCPE #30',
        img: img56,
    },
    {
        id: 57,
        //title: 'BCPE #30',
        img: img57,
    },
    
    {
        id: 58,
        //title: 'BCPE #30',
        img: img58,
    },
    {
        id: 59,
        //title: 'BCPE #30',
        img: img59,
    },
    {
        id: 60,
        //title: 'BCPE #30',
        img: img60,
    },
    {
        id: 61,
        //title: 'BCPE #30',
        img: img61,
    },
    {
        id: 62,
        //title: 'BCPE #30',
        img: img62,
    },
    {
        id: 63,
        //title: 'BCPE #30',
        img: img63,
    },
    {
        id: 64,
        //title: 'BCPE #30',
        img: img64,
    },
    {
        id: 65,
        //title: 'BCPE #30',
        img: img65,
    },

    {
        id: 66,
        //title: 'BCPE #30',
        img: img66,
    },
    {
        id: 67,
        //title: 'BCPE #30',
        img: img67,
    },
    {
        id: 68,
        //title: 'BCPE #30',
        img: img68,
    },
    {
        id: 69,
        //title: 'BCPE #30',
        img: img69,
    },
    {
        id: 70,
        //title: 'BCPE #30',
        img: img70,
    },
    {
        id: 71,
        //title: 'BCPE #30',
        img: img71,
    },
    {
        id: 72,
        //title: 'BCPE #30',
        img: img72,
    },
    {
        id: 73,
        //title: 'BCPE #30',
        img: img73,
    },
    {
        id: 74,
        //title: 'BCPE #30',
        img: img74,
    },
    {
        id: 75,
        //title: 'BCPE #30',
        img: img75,
    },
    {
        id: 76,
        //title: 'BCPE #30',
        img: img76,
    },
    {
        id: 77,
        //title: 'BCPE #30',
        img: img77,
    },
    {
        id: 78,
        //title: 'BCPE #30',
        img: img78,
    },
    {
        id: 79,
        //title: 'BCPE #30',
        img: img79,
    },
    {
        id: 80,
        //title: 'BCPE #30',
        img: img80,
    },
    {
        id: 81,
        //title: 'BCPE #30',
        img: img81,
    },
    {
        id: 82,
        //title: 'BCPE #30',
        img: img82,
    },
    {
        id: 83,
        //title: 'BCPE #30',
        img: img83,
    },
    {
        id: 84,
        //title: 'BCPE #30',
        img: img84,
    },
    {
        id: 85,
        //title: 'BCPE #30',
        img: img85,
    },
    {
        id: 86,
        //title: 'BCPE #30',
        img: img86,
    },
    {
        id: 87,
        //title: 'BCPE #30',
        img: img87,
    },
    {
        id: 88,
        //title: 'BCPE #30',
        img: img88,
    },
    {
        id: 89,
        //title: 'BCPE #30',
        img: img89,
    },
    {
        id: 90,
        //title: 'BCPE #30',
        img: img90,
    },
    {
        id: 91,
        //title: 'BCPE #30',
        img: img91,
    },
    {
        id: 92,
        //title: 'BCPE #30',
        img: img92,
    },
    {
        id: 93,
        //title: 'BCPE #30',
        img: img93,
    },
    {
        id: 94,
        //title: 'BCPE #30',
        img: img94,
    },
    {
        id: 95,
        //title: 'BCPE #30',
        img: img95,
    },
    {
        id: 96,
        //title: 'BCPE #30',
        img: img96,
    },
    {
        id: 97,
        //title: 'BCPE #30',
        img: img97,
    },
    {
        id: 98,
        //title: 'BCPE #30',
        img: img98,
    },
    {
        id: 99,
        //title: 'BCPE #30',
        img: img99,
    },
    {
        id: 100,
        //title: 'BCPE #30',
        img: img100,
    },
    {
        id: 101,
        //title: 'BCPE #30',
        img: img101,
    },
    {
        id: 102,
        //title: 'BCPE #102',
        img: img102,
    },
    {
        id: 103,
        //title: 'BCPE #103',
        img: img103,
    },
    {
        id: 104,
        //title: 'BCPE #104',
        img: img104,
    },
    {
        id: 105,
        //title: 'BCPE #105',
        img: img105,
    },
    {
        id: 106,
        //title: 'BCPE #106',
        img: img106,
    },
    {
        id: 107,
        //title: 'BCPE #107',
        img: img107,
    },
    {
        id: 108,
        //title: 'BCPE #108',
        img: img108,
    },
    {
        id: 109,
        //title: 'BCPE #109',
        img: img109,
    },
    {
        id: 110,
        //title: 'BCPE #110',
        img: img110,
    },

    {
        id: 111,
        //title: 'BCPE #110',
        img: img111,
    },

    //elon

    {
        id: 112,
        //title: 'BCPE #110',
        img: img112,
    },

    {
        id: 113,
        //title: 'BCPE #110',
        img: img113,
    },

    {
        id: 114,
        //title: 'BCPE #110',
        img: img114,
    },

    
    {
        id: 115,
        //title: 'BCPE #110',
        img: img115,
    },

    
    {
        id: 116,
        //title: 'BCPE #110',
        img: img116,
    },
    
    
    {
        id: 117,
        //title: 'BCPE #110',
        img: img117,
    },

    
    {
        id: 118,
        //title: 'BCPE #110',
        img: img118,
    },

    
    {
        id: 119,
        //title: 'BCPE #110',
        img: img119,
    },

    {
        id: 120,
        //title: 'BCPE #110',
        img: img120,
    },

    {
        id: 121,
        //title: 'BCPE #110',
        img: img121,
    },

    {
        id: 122,
        //title: 'BCPE #110',
        img: img122,
    },

    {
        id: 123,
        //title: 'BCPE #110',
        img: img123,
    },

    {
        id: 124,
        //title: 'BCPE #110',
        img: img124,
    },
 
 
 
 
 

 
    
]

export default dataProject;